import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import Badge from '@wix/da-shared-react/pkg/Badge';
import { PapiBadge } from '@wix/da-types-papi';
import s from './Badges.scss';

interface Props {
  badges: PapiBadge[];
  collapseMoreThan?: number;
}

const Badges: React.FC<Props> = ({ badges, collapseMoreThan = 6 }) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);
  const indexLimit = collapseMoreThan - 1;
  const lengthLimit = collapseMoreThan;

  return (
    <div
      className={classnames(
        s['root'],
        (isExpanded || badges.length >= collapseMoreThan) &&
          s['a-lot-of-badges']
      )}
    >
      {badges.map((badge, index) => {
        if (isExpanded || index < indexLimit || badges.length <= lengthLimit) {
          return (
            <div key={(badge as PapiBadge).id} className={s['badge-wrapper']}>
              <Badge {...(badge as PapiBadge)} />
            </div>
          );
        }
        return null;
      })}
      {badges.length > collapseMoreThan && (
        <button
          key="more-badges"
          className={s['more-badges-icon']}
          onClick={() => setIsExpanded(!isExpanded)}
          aria-label={t(
            isExpanded
              ? 'widgets.aboutMe.a11y.fewerBadges'
              : 'widgets.aboutMe.a11y.moreBadges'
          )}
        >
          {isExpanded ? '-' : `+${badges.length - lengthLimit}`}
        </button>
      )}
    </div>
  );
};
Badges.displayName = 'Badges';

export default Badges;
